import { React, useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LeaseApiService from '../../services/apiService';
import WindowedSelect from 'react-windowed-select';
import moment from 'moment';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { useSelector } from 'react-redux';
import { getUserRole } from '../../../Redux/selecters';

const TransectionDetails = ({ managerList, remarksList, reasonList, TransectionDetail, setTransectionData, transectionData, handleagentData, handleSDRefund, calculateDaysBetween, handleRentForStayedPeriod, leaseDetails }) => {
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const userRole = useSelector(getUserRole);
    const { currencyPrecision } = useCurrency();
    const isAdminOrFinance = userRole?.trim().toLowerCase() === "financeadmin";

    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        if (name === "vacatingDate") {
            let startDate = TransectionDetail?.Lease_Date
            let vacatingDate = value
            const toDate = typeof value === 'string' ? value : formatDate(value);
            let monthRent = TransectionDetail?.MonthlyRent
            let refno = TransectionDetail?.UnitRefNo || 0
            let daysstayed = calculateDaysBetween(startDate, vacatingDate)
            handleRentForStayedPeriod(startDate, toDate, monthRent)
            handleagentData(toDate, refno, TransectionDetail?.Cust1_No)
            setTransectionData((prev) => ({
                ...prev,
                dayesStayed: daysstayed,
                vacatingDate: vacatingDate
            }));
        } else {
            setTransectionData((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    }
    const handleInputChange = async (input) => {
        const name = input?.target?.name || input.name;
        let value = input?.target?.value || input.value;
        if (name === "stayedPeriod") {
            // numbers only: digits and a single decimal point
            value = String(input?.target?.value ?? "").replace(/[^0-9.]/g, "").replace(/^(\d*\.\d*).*$/, "$1");
            let totalAmountRec = transectionData?.totalAmountRec
            let RentBalance = (value - totalAmountRec)?.toFixed(currencyPrecision?.decimalNumbers)
            let TotalDedcution = transectionData?.totalDeduction || 0
            setTransectionData((prev) => ({
                ...prev,
                stayedPeriod: value,
                rentAmtBalance: RentBalance || "0.000"
            }));

            handleSDRefund(TransectionDetail?.SecurityDeposit, TotalDedcution, RentBalance)
        } else {
            setTransectionData((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    }
    const handleRemarksChange = (selectedOption) => {
        setTransectionData({
            ...transectionData,
            remarksDrop: selectedOption,
        });
    }
    const handleReasonChange = (selectedOption) => {
        setTransectionData({
            ...transectionData,
            reasondrop: selectedOption,
            vacatingReason: selectedOption?.label
        });
    }
    const handleManagerChange = (selectedOption) => {
        setTransectionData({
            ...transectionData,
            manager: selectedOption
        });
    }
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                <div className="form-group grid-contain ">
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Transaction Date</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.transDate}
                            onChange={(date) => handleDateChange({ name: 'transDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent For <br />The Period</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.rentPerPeriod} name="rentPerPeriod" disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Security Deposit</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.securityDeposit} name="securityDeposit" disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Notice Date</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.NoticeDate}
                            onChange={(date) => handleDateChange({ name: 'NoticeDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent For Stayed Periods</label>
                        <input type="text" inputMode="decimal" className="p-2 form-control w-75"
                            disabled={!isAdminOrFinance}
                            placeholder='0.000' value={transectionData?.stayedPeriod}
                            onChange={handleInputChange} name="stayedPeriod" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Total Deductions</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.totalDeduction} name="totalDeduction" disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Vacating Date</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.vacatingDate}
                            onChange={(date) => handleDateChange({ name: 'vacatingDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Total Amount Rec</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.totalAmountRec} name="totalAmountRec" disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Balance / Refund</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.sdRefund} name="sdRefund" disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 w-25 start">Date Paid on {"  "} Vacation</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.vacationDate}
                            onChange={(date) => handleDateChange({ name: 'vacationDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent Balance / Refund</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.rentAmtBalance} name="rentAmtBalance" disabled />
                    </div>
                    <div className="d-flex">
                        <div>
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Days Stayed</label>
                            <h6 className=" pt-1 text-danger">{transectionData?.dayesStayed}</h6>
                        </div>
                        <h6 className=" text-danger pt-1 start">{transectionData?.sdRefund > "0" || transectionData?.sdRefund > 0 ? "Payable" : "Receivable"}</h6>
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">keys Return Date</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.returnDate}
                            onChange={(date) => handleDateChange({ name: 'returnDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex ">
                        <h6 className=" pt-1 text-secondary">{transectionData?.monthRent?.toFixed(currencyPrecision?.decimalNumbers)}</h6>
                    </div>
                    <div className="d-flex gap-5">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Agent Comm Reversal</label>
                        <h6 className="text-danger pt-1 start">{transectionData?.agentAmount?.toFixed(currencyPrecision?.decimalNumbers)}</h6>
                    </div>
                    <div></div>
                    <div className="d-flex gap-5">
                        <h6 className=" pt-1 text-secondary">Actual Stayed Rent</h6>
                        <h6 className=" pt-1 text-danger">{transectionData?.actualStayedPeriod?.toFixed(currencyPrecision?.decimalNumbers) || "0.000"}</h6>
                    </div>
                    <div className="d-flex gap-5">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">GL Balance</label>
                        <h6 className="text-danger pt-1 start">{(transectionData?.glBalance || 0)?.toFixed(currencyPrecision?.decimalNumbers)}</h6>
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Vacating Reason</label>
                        <WindowedSelect
                            className="w-75 p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}

                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            menuShouldScrollIntoView={false}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                    color: '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000',
                                    },
                                }),
                            }}
                            value={transectionData.reasondrop}
                            onChange={(selectedOption) => handleReasonChange(selectedOption)}
                            options={remarksList?.map((rec) => ({ value: rec?.text, label: rec?.value }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Prop Manager</label>
                        <WindowedSelect
                            className="w-75 p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}

                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            menuShouldScrollIntoView={false}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                    color: '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000',
                                    },
                                }),
                            }}
                            value={transectionData.manager}
                            onChange={(selectedOption) => handleManagerChange(selectedOption)}
                            options={managerList?.map((rec) => ({ value: rec?.value, label: rec?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Reason</label>
                        <WindowedSelect
                            className="w-75 p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}

                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            menuShouldScrollIntoView={false}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                    color: '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000',
                                    },
                                }),
                            }}
                            value={transectionData.remarksDrop}
                            onChange={(selectedOption) => handleRemarksChange(selectedOption)}
                            options={reasonList?.map((rec) => ({ value: rec?.text, label: rec?.value }))}
                        />
                    </div>
                    <div>
                        <textarea type="text" className="form-control" value={transectionData?.vacatingReason} name="vacatingReason" disabled onChange={handleInputChange} />
                    </div>
                    <div className='d-flex gap-4 center'>
                        <h6>Category   :</h6>
                        <h6 className='text-danger'>{leaseDetails?.Category_Mix || "---"}</h6>
                    </div>
                    <div>
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Remarks / Comments</label>
                        <textarea type="text" className="p-2 form-control " name="remarks" onChange={handleInputChange} />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default TransectionDetails;